import dayjs from 'dayjs'

export const formatCommentDate = (date) => {
    const commentDate = dayjs(date)
    if (!commentDate.isValid()) return ''

    const today = dayjs().startOf('day')
    const daysDiff = today.diff(commentDate.startOf('day'), 'day')

    if (daysDiff <= 0) {
        return commentDate.format('MMM D')
    }
    if (daysDiff === 1) {
        return 'Yesterday'
    }
    if (daysDiff <= 7) {
        return `${daysDiff} days ago`
    }

    return commentDate.year() === today.year()
        ? commentDate.format('MMM D')
        : commentDate.format('MMM D, YYYY')
}
